<template>
  <b-modal
    id="modal-feddback-remark-add"
    ref="modal"
    v-model="open"
    size="ov-custom"
    no-close-on-backdrop
    hide-footer
    centered
    :title="`${ remarkToUpdate ? 'EDIT' : 'ADD' } FEEDBACK REMARK`"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <ValidationObserver
        v-slot="{ handleSubmit }"
        slim
      >
        <b-form
          ref="remarkForm"
          class="my-8"
          @submit.prevent="handleSubmit(remarkToUpdate ? onClickUpdate : onClickCreateRemark)"
        >
          <b-row>
            <b-col cols="12">
              <b-form-group
                v-if="canAddtFeedbackRemarkDetails || remarkToUpdate"
                label="Remark"
                label-for="h-name"
                label-cols-md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="Remark"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="form.remark"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Enter the Remark"
                    type="text"
                    maxlength="125"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- submit and reset -->
          <b-row>
            <b-col
              class="d-flex justify-content-end align-items-center"
            >
              <div>
                <b-button
                  v-if="canAddtFeedbackRemarkDetails || remarkToUpdate"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                >
                  {{ `${ remarkToUpdate ? 'Update' : 'Submit' }` }}
                </b-button>
                <b-button
                  v-if="canAddtFeedbackRemarkDetails || remarkToUpdate"
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                  @click="remarkToUpdate ? remarkToUpdate = null : () => {}"
                >
                  {{ `${ remarkToUpdate ? 'Cancel' : 'Clear' }` }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>
      <br><br>
      <feedback-remark-table
        :remarks="items"
        :set-update="setUpdate"
        :order-id="id"
        :data-loading="dataLoading"
      />
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  BCol,
  BFormGroup,
  BForm,
  BFormInput,
  BRow,
  BOverlay,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FeedbackRemarkTable from '@/components/AllOrders/Remark/FeedbackRemarkTable.vue'
import store from '@/store/index'

const remarkRepository = RepositoryFactory.get('feedbackRemark')

function initialState() {
  return {
    open: false,
    id: null,
    form: {},
    modalLoading: false,
    items: [],
    remarkToUpdate: null,
    dataLoading: false,
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BButton,
    BModal,
    BCol,
    BFormGroup,
    BForm,
    BFormInput,
    BRow,
    BOverlay,
    FeedbackRemarkTable,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  computed: {
    canAddtFeedbackRemarkDetails() {
      return store.getters.permissions.filter(permission => permission === 'feedback-remark-create').length > 0
    },
  },
  methods: {
    async openModal(id) {
      Object.assign(this.$data, initialState())
      this.open = true
      this.id = id
      await this.fetchRemarkDetails()
    },
    async fetchRemarkDetails() {
      this.dataLoading = true
      try {
        const { data } = (await remarkRepository.getRemarkList(this.id)).data
        this.items = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async onClickCreateRemark() {
      this.modalLoading = true
      try {
        const payload = {
          remark: this.form.remark,
        }
        await remarkRepository.createRemark(this.id, payload)
        this.showSuccessMessage('Remark added successfully')
        this.$parent.onClickRefresh()
        this.open = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
    setUpdate(remark) {
      this.remarkToUpdate = remark
      this.form.remark = remark.remark
    },
    async onClickUpdate() {
      try {
        this.modalLoading = true
        const payload = {
          order_id: this.id,
          remark: this.form.remark,
        }
        const res = await remarkRepository.updateRemark(this.id, this.remarkToUpdate.id, payload)
        if (res.status === 200) {
          this.showSuccessMessage('Remark updated successfully')
          this.items = this.items.map(remark => {
            if (remark.id === this.remarkToUpdate.id) {
              // eslint-disable-next-line no-param-reassign
              remark.remark = this.form.remark
            }
            return remark
          })
          this.remarkToUpdate = null
          this.$refs.remarkForm.reset()
        } else {
          this.showErrorMessage('Couldn\'t update remark')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
  },
}
</script>
<style scoped>
</style>
